export * from "./ssaoRenderingPipeline.pure";

import "../../../Shaders/ssao.fragment";
import "../../../Shaders/ssaoCombine.fragment";
